import { Injectable } from "@angular/core";
import { PolicyData } from "@core/utils/models/policy.model";
import { HttpHandler } from "@shared/utils/classes/http-handler";
import { HttpResponse } from "@shared/utils/models/http.model";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable()
export class PolicyService extends HttpHandler {
  getUserAgreement(): Observable<HttpResponse<PolicyData>> {
    const url: string = environment.apiUrls.policy.userAgreement;
    return this.get<HttpResponse<PolicyData>>(url);
  }

  getTermsOfUse(): Observable<HttpResponse<PolicyData>> {
    const url: string = environment.apiUrls.policy.termsOfUse;
    return this.get<HttpResponse<PolicyData>>(url);
  }

  getPrivacyPolicy(): Observable<HttpResponse<PolicyData>> {
    const url: string = environment.apiUrls.policy.privacyPolicy;
    return this.get<HttpResponse<PolicyData>>(url);
  }
}
